
<template>
	<div class="importExcel">
		<div class="fx-header goback">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<p>商品导入</p>
		</div>
		<div class="step-container">
			<div class="step1">下载模板</div>
			<div class="step2" :class="step >= 2 ? 'blue':''">上传数据</div>
			<div class="step3" :class="step === 3 ? 'blue':''">导入完成</div>
		</div>
		<div class="explain-container">
			<div style="font-size: 14px;">操作流程说明</div>
			<div>第 1 步：创建商品店铺级分类，导入商品需要关联已创建店铺级分类；<span style="color: var(--fx-primary-color);text-decoration:underline;cursor: pointer;" @click="goCategory">导入店铺级分类</span></div>
			<div>第 2 步：下载商品导入模板，根据文件中导入说明进行数据添加：</div>
			<div>第 3 步：上传导入数据，导入前请进行校验；</div>
		</div>
		<div class="container-box">

			<a v-if="step === 1 && bigcategoryview" class="btn" href="javascript:void(0);" @click="downloadFile(1)">
				下载商品导入模板
			</a>
			<a v-if="step === 1 && !bigcategoryview" class="btn" href="javascript:void(0);" @click="downloadFile(2)">
				下载商品导入模板
			</a>
			<div v-if="step === 1" class="btn1" @click="stepChange(2)">去上传</div>
			<div v-if="step === 2" class="step2-container">
				<div @click="importExcel" class="add-box">
					<i style="font-size: 20px;" class="el-icon-upload2"></i>
					选择上传导入文件
				</div>
				<input type="file" ref="file" id="file" accept=".xls,.xlsx" v-show="false" @change="getFile">
				<div class="beCareful-container">
					<div style="font-size: 14px;">注意事项：</div>
					<div>1.上传文件格式为 .xlsx，建议不超过5000条数据；</div>
					<div>2.上传文件表头需和下载模板一致，请不要删除或修改表头信息，门店未使用店铺级小类模板内无该字段；</div>
					<div>3.导入信息内容不能与系统已存在商品名称、商品编号和规格编号重复；</div>
					<div>4.上传文件内容全部无误后会一次性导入成功。</div>
				</div>
				<!-- <div class="btn1" >下载商品导入模板</div> -->
				<a v-if="bigcategoryview" style="margin-top: 10px;" class="btn1" href="javascript:void(0);" @click="downloadFile(1)">
					下载商品导入模板
				</a>
				<a v-if="!bigcategoryview" style="margin-top: 10px;" class="btn1" href="javascript:void(0);" @click="downloadFile(2)">
					下载商品导入模板
				</a>
			</div>
			<div v-if="step === 3" class="success-box">
				<div style="display: flex;flex-direction: row;align-items: center;">
					<i class="el-icon-success" style="color: #1EB85A;font-size: 22px;margin-right: 20px;"></i>
					<span style="font-size: 18px;font-weight: bold;color: #333333;">数据导入完成</span>
				</div>
				<div style="display: flex;flex-direction: row;align-items: center;margin-top: 80px;">
					<el-button @click='goBack' size='mini' style="width: 120px;margin-right: 30px;">去可售商品查看</el-button>
					<el-button @click='continueClick' size='mini' style="width: 120px;" type='primary'>继续导入</el-button>
				</div>
			</div>
		</div>
		<el-dialog title="提示" class="dialog-title" :visible.sync="tipModal" width='400px' :close-on-click-modal="false">
			<div style="height: 300px;overflow-y: auto;">
				<div style="padding-bottom:20px;text-align: left;" v-for="item in tipData" :key="item">
					{{item}}
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'importExcel',
	data () {
		return {
			bigcategoryview: false,
			step: 1,
			tipModal: false,
			tipData: []
		}
	},
	created () {
		this.checkSmallCategory()
	},
	methods: {
		// 是否开启小类
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				console.log(res)
				this.bigcategoryview = res.bigcategoryview === 1
			})
		},
		continueClick () {
			this.step = 1
		},
		// 导入
		importExcel () {
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		getFile (e) {
			this.uploadGoodsHandle()
			this.$refs.file.value = ''
		},
		uploadGoodsHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				formData.append('shopid', window.sessionStorage.getItem('storeid'))
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/product/importExcel`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.step = 3
					} else {
						this.tipData = res.data
						this.tipModal = true
					}
				})
			})
		},
		goBack () {
			this.$router.push('/main/saleableGoods')
		},
		goCategory () {
			this.$router.push('/main/categoryManagement')
		},
		stepChange (num) {
			this.step = num
		},
		downloadFile (val) {
			let url = ''
			if (val === 1) {
				url = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/business/qshop/product/【极速订】商品数据导入模板.xlsx?timeStamp=' + new Date().getTime()
			} else {
				url = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/business/qshop/product/product/【极速订】商品数据导入模板.xlsx?timeStamp=' + new Date().getTime()
			}
			window.location.href = url
		}
	}
}
</script>

<style lang="stylus" scoped>
.importExcel {
	overflow :auto;
	display flex;
	flex-direction column;
	width :100%;
	height: 100%;
	min-height: 0;
	.goback{
		span {
			float left
			display inline-block
			line-height 55px
			padding-right 20px
			margin-top :10px
			i {
				border-radius: 50%;
				background: #9da6af;
				padding: 3px;
				cursor: pointer;
			}
			.el-icon-back:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
	}
	.blue{
		background-color : var(--fx-primary-color) !important;
		color:white !important;
	}
	.blue::after{
		border-left: 25px solid var(--fx-primary-color) !important
	}
	.step-container{
		display flex;
		margin :20px 0px;
		flex-direction :row;
		width :100%;
		.step1{
			flex:1;
			display: flex;
			height:46px;
			align-items :center;
			justify-content:center;
			color:white;
			font-size :15px;
			font-weight 500;
			position :relative;
			background-color: var(--fx-primary-color)
			z-index :80
		}
		.step1::before{
			content: '';
			width: 0;
			height: 0;
			border-top: 23px solid transparent;
			border-left: 25px solid var(--fx-primary-color);
			border-bottom: 23px solid transparent;
			position: absolute;
			top: 0px;
			right: -25px;
		}
		.step2{
			align-items :center;
			justify-content:center;
			flex:1;
			color:#999999;
			font-size :15px;
			font-weight 500;
			display: flex;
			height:46px;
			position :relative;
			background-color: #ECEEF5
			z-index :60
		}
		.step2::before{
			content: '';
			width: 0;
			height: 0;
			border-top: 28px solid transparent;
			border-left: 33px solid white;
			border-bottom: 28px solid transparent;
			position: absolute;
			top: -5px;
			left: 0px;
		}
		.step2::after{
			content: '';
			width: 0;
			height: 0;
			border-top: 23px solid transparent;
			border-left: 25px solid #ECEEF5;
			border-bottom: 23px solid transparent;
			position: absolute;
			top: 0px;
			right: -25px;

		}
		.step3::before{
			content: '';
			width: 0;
			height: 0;
			border-top: 28px solid transparent;
			border-left: 33px solid white;
			border-bottom: 28px solid transparent;
			position: absolute;
			top: -5px;
			left: 0px;
		}
		.step3{
			flex:1;
			display: flex;
			align-items :center;
			justify-content:center;
			color:#999999;
			font-size :15px;
			font-weight 500;
			height:46px;
			position :relative;
			background-color: #ECEEF5
			z-index :40
		}
	}
	.explain-container{
		width 100%;
		height:140px;
		border:1px solid #dce2fd;
		border-radius :9px;
		display :flex;
		flex-direction:column;
		font-size 12px;
		padding :10px 20px;
		text-align :left;
		line-height:30px;
		box-sizing :border-box;
	}
	.container-box{
		width:100%;
		flex :1;
		box-sizing :border-box;
		border:1px solid #dce2fd;
		border-radius :9px;
		margin:20px 0px;
		padding :10px 20px;
		display :flex;
		flex-direction: column;
		justify-content : space-between;
		align-items :center
	}
	.btn{
		width:200px;
		margin-top:40px;
		border-radius:9px;
		border:1px solid var(--fx-primary-color);
		color:var(--fx-primary-color);
		height:40px;
		display:flex;
		align-items:center;
		justify-content:center;
		cursor:pointer
	}
	.btn1{
		width:200px;
		border-radius:9px;
		background-color: var(--fx-primary-color);
		color:white;
		height:40px;
		display:flex;
		align-items:center;
		justify-content:center;
		cursor:pointer
	}
	.step2-container{
		width :100%;
		height :100%;
		display :flex;
		flex-direction :column;
		align-items :center
		.add-box{
			width :100%;
			margin: 10px;
			height:115px;
			border-radius :9px;
			border: 1px solid var(--fx-primary-color);
			box-sizing :border-box;
			display :flex;
			align-items: center;
			justify-content:center;
			color :var(--fx-primary-color);
			cursor :pointer
		}
	}
	.beCareful-container{
		width:100%;
		line-height :30px;
		flex:1;
		display :flex;
		flex-direction column;
		text-align :left;
		box-sizing :border-box;
		color:#999999
	}
	.success-box{
		margin-top :50px;
		display:flex;
		flex-direction: column;
		align-items: center;
		justify-content :center
	}
}
</style>
<style lang="stylus">
.dialog-title{
	.el-dialog__header{
		text-align :left
	}
	.el-dialog__body{
		padding 10px;
	}
}
</style>
